<template>

  <v-flex
    v-show='field.type!=="hidden"'
    v-if='visible'
    xs12
    :sm6="!field.full && !field.semifull && !field.semisemifull"
    :md1="field.minimini || field.md == 1"
    :md2="field.mini || field.md == 2"
    :md3="field.slim || field.md == 3"
    :md4="field.small || field.md == 4"
    :md5="field.md == 5"
    :md6="(!field.small && !field.full && !field.semifull && !field.semisemifull && !field.md) || field.md == 6"
    :md7="field.md == 7"
    :md8="field.semisemifull || field.md == 8"
    :md9="field.semifull || field.md == 9"
    :md10="field.md == 10"
    :md11="field.md == 11"
    :md12="field.full || field.md == 12"
    :sm12="field.full"
    :class="select && 'pa-0 ma-0'"
  >

    <component
      v-if="field.type === 'component'"
      :is="field.name"
      v-on="field.on && field.on(this)"
      v-bind="field.bind"
      :readonly="readonly"
      :disabled="readonly"
      :item="item"
      :value="value"
      @input="updateValue"
      :id="`input_${field.value}`"
    />
    
    <v-text-field
      v-if="field.type === 'text' || field.type === 'number' || !field.type"
      :type="field.type === 'number' ? 'number' : 'text'"
      :value="value"
      :rules="!readonly ? rules : []"
      :label="field.text"
      :readonly="readonly"
      :disabled="readonly"
      :clearable="field.clearable || false"
      @input="updateValue"
      :id="`input_${field.value}`"
    />

    <v-select
      v-if="field.type === 'list'"
      :disabled="readonly"
      :multiple="field.multiple"
      :chips="field.multiple"
      :small-chips="field.multiple"
      deletable-chips
      :value="value"
      :items="computedList()"
      :rules="!readonly ? rules : []"
      :label="field.text"
      clearable
      :item-text="field.title || 'name'"
      :item-value="field.id || 'id'"
      md4
      @input="updateValue"
      :id="`input_${field.value}`"
    />

      <!-- :search-input.sync="searchString" -->

  <!--v-text-field
      v-if="field.type === 'autocomplete'  && readonly"
       :value="readonlyAutocomplete"
      :label="!this.select ? field.text : ''"
      readonly
      disabled
      /-->

    <v-autocomplete
      v-if="field.type === 'autocomplete'"
      :disabled="readonly"
      :value="value"
      :items="items"
      :rules="!readonly ? rules : []"
      :multiple="field.multiple"
      :chips="field.multiple"
      :small-chips="field.multiple"
      deletable-chips
      :return-object="field.return_object || false"
      no-filter
      :loading="loading"
      :label="!this.select ? field.text : ''"
      :search-input.sync='search'
      :placeholder="field.placeholder || `Choose a ${field.text}...`"
      :class="this.select ? 'ma-0 pa-0' : ''"
      color="green"
      hide-no-data
      :item-text="field.title || 'name'"
      :item-value="field.id || 'id'"
      :prepend-icon="!this.select ? 'mdi-database-search' : ''"
      md4
      clearable
      @change="updateValue"
      :id="`input_${field.value}`">
      <template v-slot:item="{ item }">
        <v-list-item-content two-line>
          <v-list-item-title v-text="autocompleteTitle(item)"/>
          <v-list-item-subtitle v-text="autocompleteSubtitle(item)"/>
        </v-list-item-content>
      </template>
    </v-autocomplete>

      <!-- :search-input.sync="searchString" -->
    <v-combobox
      v-if="field.type === 'combobox'"
      :disabled="readonly"
      :value="value"
      :items="items"
      :rules="!readonly ? rules : []"
      :multiple="field.multiple ? field.multiple : false"
      :loading="loading"
      :label="field.text"
      :placeholder="field.placeholder != undefined ? field.placeholder : `Choose a ${field.text}...`"
      color="green"
      hide-no-data
      :append-icon="field.append_icon != undefined ? field.append_icon : 'mdi-menu-down'"
      @keydown.space.prevent
      :item-text="field.title || 'name'"
      :item-value="field.id || 'id'"
      prepend-icon_="mdi-database-search"
      :chips="field.chips != undefined ? field.chips : false"
      :deletable-chips="field.deletable_chips || false"
      :small-chips="field.multiple"
      md4
      @blur="search = ''"
      clearable
      @change="updateValue"
      :id="`input_${field.value}`"
      >
    </v-combobox>


    <v-file-input
      v-if="field.type === 'file'"
      @change='updateValue'
      :accept="field.accept || 'application/pdf'"
      :label="field.text"
      :rules='!readonly ? rules : []'
      :id="`input_${field.value}`"
    />

    <v-checkbox
      v-if="field.type === 'check'"
      :disabled="readonly"
      :label="field.text"
      :true-value="1"
      :false-value="0"
      :input-value='value'
      full-width
      required
      @change="updateValue"
      :id="`input_${field.value}`"
    />

    <v-textarea
      v-if="field.type === 'textarea'"
      :value="value"
      :rows="3"
      :rules="!readonly ? rules : []"
      :label="field.text"
      :disabled="readonly"
      @input="updateValue"
      :id="`input_${field.value}`"
    />

    <v-menu
      v-if="field.type === 'date'"
      ref="menu_datePicked"
      v-model="menu_datePicker"
      :disabled="readonly"
      :close-on-content-click="false"
      :rules="rules"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="value"
          :rules="!readonly ? rules : []"
          :label="field.text"
          v-bind="attrs"
          :clearable='!readonly'
          :disabled='readonly'
          readonly
          v-on="on"
          :id="`input_${field.value}`"
        />
      </template>
      <v-date-picker
        :disabled="readonly"
        :rules="rules"
        dark
        :value='value'
        no-title
        :min="field.min && field.min === true ? new Date().toISOString() : field.min"
        @input="dateChange"
      />
    </v-menu>

    <core-datetime-picker 
       v-if="field.type === 'datetime'"
        ref="menu_datePicked"
        :datetime="value"
        :disabled="readonly"
        :close-on-content-click="false"
        :label="field.text"
        :rules="!readonly ? rules : []"
        @input="updateValue"
        :clearable="field.clearable"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
        :id="`input_${field.value}`"
    />

    <!-- <template slot="item" slot-scope="{ item }" >
      <v-list-tile-content>
          <v-list-tile-title>{{item.name}}</v-list-tile-title>
        </v-list-tile-content>
    </template> -->
    <!-- </v-autocomplete> -->

    <v-text-field
      v-if="field.type === 'password'"
      :readonly="readonly"
      :value="value"
      :rules="!readonly ? rules : []"
      :label="field.text"
      type="password"
      autocomplete="new-password"
      @input="updateValue"
      :id="`input_${field.value}`"
    />

  </v-flex>
</template>
<script>
/**
 * Autocomplete config example:
 * 
 */
import validators from '@/utils/validators'
import get from 'lodash/get'
import uniqBy from 'lodash/unionBy'
const { getList } = require('@/api/base_entity')

export default {
  props: {
    field: { type: Object, default: () => ({}) },
    readonly: { type: Boolean, default: false },
    select: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean, File, Date, Array, Object], default: undefined },
    item: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      cachedItems: [],
      items: [],
      visible: false,
      search: '',
      loading: false,
      menu_datePicker: false
    }
  },
  watch: {
    async value(val) {
      
       if ((this.field.type === 'autocomplete' || this.field.type === 'combobox') && this.field.loadRemote != false) {

        // // cache values
        if (val) {
          if (this.field.multiple) {
            if (val.length) {
              this.loading = true
              if(this.field.return_object) {
                this.cachedItems = val
              } else {
                const id = this.field.id || this.field.value.split('_')[1]
                this.cachedItems = await getList(this.autocomplete_entity, { [id]: val }).then(ret => ret.data)
              }
            }
          } else {
             if(this.field.return_object) {
              this.cachedItems = val
             } else {
              const id = this.field.id || this.field.value.split('_')[1]
              this.cachedItems = await getList(this.autocomplete_entity, { [id]: val }).then(ret => ret.data)
            }
          }
        }
        this.updateAutocomplete()
      }
    },
    search (val, oldval) {
      if (oldval) {
        this.updateAutocomplete()
      }
    }
  },
  computed: {
    autocomplete_entity () {
      return this.field.reference || this.field.value.split('_')[0]
    },
    rules () {
      if (!this.field.validators) return []
      return this.field.validators.map(v => {
        if (typeof v === 'function') {
          return () => v(this.field, this.value, this.item)
        }
        return typeof validators[v] === 'function' ? validators[v](this.field.text) : validators[v]
      })
    },
    readonlyAutocomplete () {

       if (typeof this.field.render === 'function') {
         return this.field.render(this.item)
       }
       return null

    },
  },
  async created () {
    
    this.items = this.field.items
    
    if ((this.field.type === 'autocomplete' || this.field.type === 'combobox') && this.field.loadRemote != false) {

      // cache values
      if (this.value) {
        if (this.field.multiple) {
          if (this.value.length) {
            this.loading = true
            if(this.field.return_object) {
              this.cachedItems = this.value
            } else {
              const id = this.field.id || this.field.value.split('_')[1]
              this.cachedItems = await getList(this.autocomplete_entity, { [id]: this.value }).then(ret => ret.data)
            }
          }
        } else {
            const id = this.field.id || this.field.value.split('_')[1]
            this.cachedItems = await getList(this.autocomplete_entity, { [id]: this.value }).then(ret => ret.data)
        }
      }
      this.updateAutocomplete()
      if ((this.field.filter || this.field.list) && this.field.deps) {
        this.$root.$on('itemUpdated', this.updateAutocomplete)
      }
    }

    if (this.field.type === 'check' && this.value === null) { 
      this.$emit('input', 0)
    }

    // if (typeof this.field.render === 'function' ) {
    //   this.$emit('input', this.field.render(this.item))
    // }

    if (typeof this.field.default === 'function') {
      if (this.field.deps) {
        this.$root.$on('itemUpdated', this.updateDefault)
      }
      if (typeof this.value === 'undefined' || this.value === null) {
        this.updateDefault({ field: { value: this.field.deps ? this.field.deps[0] : null } })
      }
    }

    if (typeof this.field.visible === 'function') {
      if (this.field.deps) {
        this.$root.$on('itemUpdated', this.updateVisibility)
      }
      this.visible = this.field.visible(this.item, this.$store.state)
    } else if (typeof this.field.visible === 'boolean') {
      this.visible = this.field.visible
    } else {
      this.visible = true
    }

    //  should check if already evaluated
    if (this.field.default) {
      this.$emit('value', this.field.default)
    }    
  },
  destroyed () {
    this.$root.$off('itemUpdated')
    this.$root.$off('itemUpdated')
  },
  methods: {
    computedList () {
      if (typeof this.field.list === 'function') {
        return this.field.list(this.item, this.$store.state)
      }
      return this.field.list
    },    
    dateChange (v) {
      this.$emit('input', v)
      this.menu_datePicker = false
    },
    autocompleteSubtitle (item) {
      if (!this.field.subtitle) return
      if (typeof this.field.subtitle === 'string') {
        return get(item, this.field.subtitle)
      }
      return this.field.subtitle(item)
    },
    autocompleteTitle (item) {
      if (!this.field.title) return
      if (typeof this.field.title === 'string') {
        return get(item, this.field.title)
      }
      return this.field.title(item)
    },    
    async updateAutocomplete (args) { // (field = null) {
      if (args !== undefined &&
        (!this.field.deps || !this.field.deps.includes(args.field.value))) {
          return
        }
      this.loading = true
      if (typeof this.field.list === 'function') {
        // if(this.search) {
          let items = await this.field.list(this.autocomplete_entity, this.search, this.item).then(ret => ret.data)
          if (this.cachedItems) {
            items = items.concat(this.cachedItems)
          }
          this.items = items
        // }
      } else {
        const filters = this.field.filter ? this.field.filter(this.item, this.search) : {}
        if (this.search && !filters[this.field.title] && typeof this.field.title !== 'function') {
          filters[this.field.title] = '%' + this.search + "%"
        }
        let items = await getList(this.autocomplete_entity, filters).then(ret => ret.data)
        if (this.cachedItems) {
          items = items.concat(this.cachedItems)
        }
        this.items = uniqBy(items, this.field.id || this.field.value.split('_')[1])
      }
      this.loading = false
    },
    updateVisibility (args) {
      if (args === undefined || !this.field.deps || !this.field.deps.includes(args.field.value)) {
        return
      }
      this.visible = this.field.visible(this.item, this.$store.state, args && args.field, args.selectedItem)
    },
    updateDefault (args) {
      if (args === undefined || !this.field.deps || !this.field.deps.includes(args.field.value)) {
        return
      }
      const value = this.field.default(this.item, args && args.field, args.selectedItem, this.$store.state)
      this.$emit('input', value)
      this.$root.$emit('itemUpdated', { field: this.field, selectedItem:  args && args.selectedItem })

    },
    updateValue (value) {
      
      if (this.field.type === 'number') { value = Number(value) }

      if (this.field.type === 'combobox' && !this.field.multiple && typeof value === 'object') {
        value = value === null ? null : value[this.field.id || 'id']
      }

      this.$emit('input', value)
      let selectedItem
      if (this.field.type === 'autocomplete' || this.field.type === 'combobox') {
        selectedItem = this.items.find(item => item[this.field.id || 'id'] === value)
      }
      this.$nextTick( () => {
        this.$root.$emit('itemUpdated', { field: this.field, selectedItem })
        this.$emit('input:field', { field: this.field, selectedItem })
      })

      if (typeof this.field.onUpdate === 'function') {
          this.field.onUpdate( this.field, this.item )
      }

    }
  }
}
</script>
